import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { RenderedFormService } from '../rendered-form.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-provider-access-request',
  styleUrls: ['./provider-access-request.component.scss'],
  templateUrl: './provider-access-request.component.html'
})
export class ProviderAccessRequestComponent implements OnInit {
  @Output() flNext = new EventEmitter();

  constructor(public renderedFormService: RenderedFormService) {}

  ngOnInit() {}

  setValue(value: boolean): void {
    this.renderedFormService.dynamicModels['INVESTOR.PROVIDER_ACCESS'] = value;
    this.flNext.emit();
  }
}
